export const SETTINGS = {
  awsBaseUrl: 'https://plugins.mngdigisubs.com/',
  environment: 'Prod',
  entitler: {
    baseUrl: 'https://user.mng-digisubs-prod.com/',
    apiKey: 'DHL8Vs1UNo9u0WO52dVBzSuLi4kw2so25cXK1fy7',
  },
  uiCacheTime: 600,
  initCacheTime: 600,
  auth0: {
    domain: 'login.npuserlogin.com',
    callbackURL: window.location.origin + '/callback',
    audience: 'https://mng/authapi',
    responseType: 'token id_token',
    scopes: 'openid email profile user_metadata app_metadata offline_access',
  },
};
